'use client'
import React from "react";
import ScrollButton from "../Common/scrollButton";
import Image from "next/image";
import Link from "next/link";
import { BudgetPlanCardsContentProps, BudgetPlanCardsProps } from "@/lib/content/weddingBudgetContent/budgetPlanCardsContent";
import { useParams } from 'next/navigation';



export const BudgetPlanningTools = ({
    cardsData,
    topContent
}: {
    cardsData: BudgetPlanCardsProps[];
    topContent: BudgetPlanCardsContentProps
}) => {

    const params = useParams(); 

    return (
        <div className="relative w-full  bg-secondary " >
            <div className="p-5 pt-16 desktop-padding relative z-10" >
                <h2 className="h2 text-center " >Integrating your budget with other wedding planning tools</h2>
                <p className="mt-[28px] body-reg" >Integrating your wedding budget template with other planning tools ensures a comprehensive and cohesive approach. Tools like checklists, vendor managers, and guest list managers work harmoniously with your budget, improving the planning process.</p>
                <p className=" mt-[24px] body-reg" >This integration helps manage all aspects of your wedding seamlessly. See below for a few of our other free wedding planning templates to help make wedding planning easy.</p>

                <div className="lg:grid lg:grid-cols-3 flex flex-wrap mt-[46px] justify-center gap-[54px]">
                    {cardsData.map((card, index) => (
                        <div key={index} className="bg-[#F1F1F1] min-h-[377px] flex flex-col justify-between px-6 pt-6 pb-[28px] overflow-hidden">
                            <div>
                                <Image
                                    src={card.image}
                                    alt={card.image_alt}
                                    width={386}
                                    height={268}
                                    className="w-full h-64 object-cover"
                                />
                                <div className="px-2 sm:px-0 py-3 body-lg-bold">
                                    {card.heading}
                                </div>

                                <div
                                    className="body-reg px-2 pb-2 sm:pb-0 sm:px-0"
                                >
                                    <p>{card.description}</p>
                                </div>

                            </div>

                            <Link href={`/${params.locale}${card.href}`} >
                                <div className="flex  justify-center mt-[54px] "  >
                                    <ScrollButton
                                        variant="default"
                                        size="xlFixed"
                                        className="bg-primary py-4 text-secondary !font-bold  lg:text-wrap xl:text-nowrap "
                                        name={card.button}
                                        onClick={() => { }}
                                    ></ScrollButton>
                                </div>
                            </Link>


                        </div>
                    ))}
                </div>

            </div>
        </div>
    )
}